import { useState } from 'react'
import { useApiClient } from '@/hooks'
import { downloadApiResponse } from '@/utils'

export type ExpensesExportParams = {
  startDate?: string
  endDate?: string
  researchers?: string
  isExported?: boolean
}

export const useExpensesExport = () => {
  const client = useApiClient()

  const [loading, setLoading] = useState(false)

  const exportExpenses = async ({
    startDate,
    endDate,
    researchers,
    isExported,
  }: ExpensesExportParams) => {
    const queryParams = new URLSearchParams()

    if (startDate) queryParams.append('date_start', startDate)
    if (endDate) queryParams.append('date_end', endDate)
    if (researchers) queryParams.append('researchers', researchers)
    if (isExported !== undefined) {
      queryParams.append('is_exported', isExported ? 'true' : 'false')
    }

    setLoading(true)
    try {
      const endpoint = '/hours_reporting/hr/expenses/export-pdf/'

      const response = await client.get<Blob>(
        `${endpoint}?${queryParams.toString()}`,
        { responseType: 'blob' }
      )

      downloadApiResponse(response)
    } finally {
      setLoading(false)
    }
  }

  return { exportExpenses, loading }
}
